/**
 * @generated SignedSource<<38cef98c44dd3e578da4e6b818898188>>
 * @relayHash fc25c87c64c90bb0fea80756cd9aa3be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8e629667f63aa2e4f893827457e519864aa139f6bc57f7d478a579c9b3c644c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b8e629667f63aa2e4f893827457e519864aa139f6bc57f7d478a579c9b3c644c",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
